import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import JBImage from 'components/essentials/JBImage';
import JBResponsiveImage from 'components/essentials/JBResponsiveImage';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import definition from './definition.yaml';

// Matches the previous CSS background render box. Keep these as `ar` on
// <source> elements — JBImage strips width/height for renderAsSource.
const MOBILE_BACKGROUND_AR = '798:358';
const DESKTOP_BACKGROUND_AR = '540:560';

// Text panel is 100vw on small screens (2x ≈ 2048) or 480-540px on desktop.
const TEXT_PANEL_SRCSET_WIDTHS = [360, 540, 720, 960, 1080, 1600, 2048];
const BannerTextSection = t0 => {
  const $ = _c(73);
  const {
    className,
    config,
    fullWidth: t1,
    variant,
    isHomepageHero: t2
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const isHomepageHero = t2 === undefined ? false : t2;
  const {
    textContent: t3,
    colors: t4,
    cta,
    ctaColors: t5,
    toggleInputType,
    isCarousel: t6
  } = config;
  let t7;
  if ($[0] !== t3) {
    t7 = t3 === undefined ? {} : t3;
    $[0] = t3;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const textContent = t7;
  let t8;
  if ($[2] !== t4) {
    t8 = t4 === undefined ? {} : t4;
    $[2] = t4;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const colors = t8;
  let t9;
  if ($[4] !== t5) {
    t9 = t5 === undefined ? {} : t5;
    $[4] = t5;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const ctaColors = t9;
  const isCarousel = t6 === undefined ? false : t6;
  const [iFrameVisibility, setIFrameVisibility] = useState(false);
  const {
    backgroundImage,
    icon,
    heroFancyText,
    heroFancyTextColor,
    heroLogomark,
    body,
    title,
    disclaimer,
    iconWidth: t10
  } = textContent;
  const iconWidth = t10 === undefined ? "50%" : t10;
  let t11;
  if ($[6] !== colors) {
    t11 = get(colors, "textHex", definition.props.colors.textHex);
    $[6] = colors;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const colorsTextHex = t11;
  let t12;
  if ($[8] !== ctaColors) {
    t12 = get(ctaColors, "backgroundHex", definition.props.ctaColors.backgroundHex);
    $[8] = ctaColors;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const ctaColorsBackgroundHex = t12;
  let t13;
  if ($[10] !== ctaColors) {
    t13 = get(ctaColors, "textHex", definition.props.ctaColors.textHex);
    $[10] = ctaColors;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const ctaColorsTextHex = t13;
  let t14;
  if ($[12] !== ctaColorsBackgroundHex) {
    t14 = {
      backgroundColor: ctaColorsBackgroundHex
    };
    $[12] = ctaColorsBackgroundHex;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== ctaColorsTextHex) {
    t15 = {
      color: ctaColorsTextHex
    };
    $[14] = ctaColorsTextHex;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t14 || $[17] !== t15) {
    t16 = {
      background: t14,
      text: t15
    };
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const ctaStyles = t16;
  const isFullWidthPanel = fullWidth || variant === "ShopPagePromotionPanel";
  const backgroundSizes = isFullWidthPanel ? "100vw" : "(max-width: 1023px) 100vw, (max-width: 1439px) 480px, 540px";
  const t17 = `relative px-5 py-8 flex flex-none h-full w-full flex-col justify-center overflow-hidden md:px-[3.333vw] md:py-8 lg:[text-align:initial] lg:min-w-[480px] lg:px-[3.333vw] lg:py-0 lg:w-[480px] min-[1440px]:min-w-[540px] min-[1440px]:w-[540px] ${className}`;
  const t18 = variant === "ShopPagePromotionPanel";
  let t19;
  if ($[19] !== fullWidth || $[20] !== isCarousel || $[21] !== t17 || $[22] !== t18) {
    t19 = cx(t17, {
      "lg:min-w-full lg:w-full": fullWidth,
      "pl-[calc(3.333vw_+_20px)]": isCarousel,
      "!p-[55px] !w-full !min-w-full !rounded-[.5rem] md:max-[1023px]:!rounded-none": t18
    });
    $[19] = fullWidth;
    $[20] = isCarousel;
    $[21] = t17;
    $[22] = t18;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== backgroundImage || $[25] !== backgroundSizes || $[26] !== isFullWidthPanel || $[27] !== isHomepageHero) {
    t20 = backgroundImage && <div aria-hidden="true" className={cx("absolute inset-0 z-0 [&_picture]:block [&_picture]:h-full [&_picture]:w-full", {
      "max-lg:hidden": isHomepageHero
    })} data-xc={isHomepageHero ? "homepage-hero-artwork" : undefined}><JBResponsiveImage>{!isHomepageHero && <JBImage alt="" ar={MOBILE_BACKGROUND_AR} auto="format,compress" crop="center" fit="crop" lazy={false} media="(max-width: 1023px)" renderAsSource={true} sizes="100vw" src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} />}<JBImage alt="" ar={DESKTOP_BACKGROUND_AR} auto="format,compress" crop="center" fit="crop" lazy={false} media="(min-width: 1024px)" renderAsSource={true} sizes={isFullWidthPanel ? "100vw" : "(max-width: 1439px) 480px, 540px"} src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} /><JBImage alt="" ar={DESKTOP_BACKGROUND_AR} auto="format,compress" className="h-full w-full object-cover" crop="center" fit="crop" lazy={isHomepageHero} priority={!isHomepageHero} sizes={isHomepageHero ? "(max-width: 1439px) 480px, 540px" : backgroundSizes} src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} /></JBResponsiveImage></div>;
    $[24] = backgroundImage;
    $[25] = backgroundSizes;
    $[26] = isFullWidthPanel;
    $[27] = isHomepageHero;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== icon || $[30] !== iconWidth) {
    t21 = icon && <img className="mb-5 w-1/2 max-w-[260px] md:max-w-[50%]" src={icon} alt="Icon" style={{
      width: iconWidth
    }} />;
    $[29] = icon;
    $[30] = iconWidth;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== heroLogomark) {
    t22 = heroLogomark && <JBImage className="mb-5" src={heroLogomark} width={400} height={200} />;
    $[32] = heroLogomark;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== heroFancyText || $[35] !== heroFancyTextColor) {
    t23 = heroFancyText && <span className="mb-5 text-[1.4rem] non-italic font-normal md:text-[1.4rem]" style={{
      color: heroFancyTextColor
    }}>{heroFancyText}</span>;
    $[34] = heroFancyText;
    $[35] = heroFancyTextColor;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== colorsTextHex) {
    t24 = {
      color: colorsTextHex
    };
    $[37] = colorsTextHex;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t24 || $[40] !== title) {
    t25 = <h1 className="text-4xl font-bold mb-3 md:mb-5" style={t24}>{title}</h1>;
    $[39] = t24;
    $[40] = title;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== body || $[43] !== colorsTextHex) {
    t26 = body && <p className="text-base font-bold mb-6 md:text-lg md:font-bold" style={{
      color: colorsTextHex
    }}>{body}</p>;
    $[42] = body;
    $[43] = colorsTextHex;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== cta || $[46] !== ctaStyles) {
    t27 = !!cta && cta.content && (!cta.embedCode || !cta.embedCode.enabled) && <div><CtaLink style={ctaStyles} to={cta.linkTo} styling={cta.style} color="brand">{cta.content}</CtaLink></div>;
    $[45] = cta;
    $[46] = ctaStyles;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== ctaStyles || $[49] !== toggleInputType) {
    t28 = !!toggleInputType && <ToggleCTALinkButton style={ctaStyles} toggleInputType={toggleInputType} />;
    $[48] = ctaStyles;
    $[49] = toggleInputType;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== cta || $[52] !== ctaStyles || $[53] !== iFrameVisibility || $[54] !== toggleInputType) {
    t29 = !toggleInputType && !!cta && cta.embedCode && cta.embedCode.enabled && <div>{iFrameVisibility ? <JBIFrameHolder isOpen={iFrameVisibility} onClose={setIFrameVisibility} script={cta.embedCode.value || ""} /> : null}<CtaButton style={ctaStyles} onClick={() => {
        setIFrameVisibility(true);
      }} color={cta.color || "brand"} styling={cta.style || "solid-button"}>{cta.content}</CtaButton></div>;
    $[51] = cta;
    $[52] = ctaStyles;
    $[53] = iFrameVisibility;
    $[54] = toggleInputType;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== colorsTextHex || $[57] !== disclaimer) {
    t30 = disclaimer && <p className="mt-4 mb-0 opacity-75 md:mt-6 text-xs font-bold" style={{
      color: colorsTextHex
    }}>{disclaimer}</p>;
    $[56] = colorsTextHex;
    $[57] = disclaimer;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t21 || $[60] !== t22 || $[61] !== t23 || $[62] !== t25 || $[63] !== t26 || $[64] !== t27 || $[65] !== t28 || $[66] !== t29 || $[67] !== t30) {
    t31 = <div className="relative z-10">{t21}{t22}{t23}{t25}{t26}{t27}{t28}{t29}{t30}</div>;
    $[59] = t21;
    $[60] = t22;
    $[61] = t23;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
    $[67] = t30;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== t19 || $[70] !== t20 || $[71] !== t31) {
    t32 = <div className={t19}>{t20}{t31}</div>;
    $[69] = t19;
    $[70] = t20;
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  return t32;
};
BannerTextSection.propTypes = {
  config: PropTypes.shape({
    colors: PropTypes.shape({
      textHex: PropTypes.string
    }),
    cta: PropTypes.shape({
      color: PropTypes.string,
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string
      }),
      linkTo: PropTypes.string,
      style: PropTypes.string
    }),
    ctaColors: PropTypes.shape({
      backgroundHex: PropTypes.string,
      textHex: PropTypes.string
    }),
    isCarousel: PropTypes.bool,
    textContent: PropTypes.shape({
      backgroundImage: PropTypes.string,
      body: PropTypes.string,
      disclaimer: PropTypes.string,
      heroFancyText: PropTypes.string,
      heroFancyTextColor: PropTypes.string,
      icon: PropTypes.string,
      iconWidth: PropTypes.string,
      title: PropTypes.string
    }),
    toggleInputType: PropTypes.object
  }),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['ShopPagePromotionPanel'])
};
export default BannerTextSection;